(() => {
  const root = window.Shopify?.routes?.root || '/';
  const surfaces = '[data-tazty-cart-page], #TaztyCartDrawer';
  const controls = '[data-cart-ice-bag-toggle], [data-cart-step], [data-cart-quantity], [data-cart-remove], [data-cart-clear], [name="checkout"]';
  let busy = false;

  const status = (message, error = false) => {
    document.querySelectorAll('[data-ice-bag-status]').forEach(node => {
      node.textContent = message;
      node.toggleAttribute('data-error', error);
    });
  };
  const request = async (url, body) => {
    const response = await fetch(url, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      signal: AbortSignal.timeout(15000),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'The ice bag could not be updated. Please try again.');
    return result;
  };

  // Block conflicting cart actions and checkout until the server update completes.
  document.addEventListener('click', event => {
    if (busy && event.target.closest(`${controls}, [data-cart-drawer-open]`)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (busy && event.target.closest(surfaces)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('change', event => {
    if (busy && event.target.matches(controls)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const input = event.target.closest('[data-cart-ice-bag-toggle]');
    if (!input) return;
    const waiting = [...document.querySelectorAll(surfaces)].some(node => node.getAttribute('aria-busy') === 'true');
    if (waiting) {
      input.checked = input.defaultChecked;
      status('Please wait for the current cart update to finish.');
      return;
    }
    update(input);
  }, true);

  async function update(input) {
    const variantId = Number(input.dataset.variantId);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
    const wanted = input.checked;
    const wasChecked = input.defaultChecked;
    const scope = input.closest(surfaces);
    const sectionIds = [...new Set([...document.querySelectorAll(surfaces)].map(node => node.dataset.sectionId).filter(Boolean))];
    busy = true;
    const disabled = [...document.querySelectorAll(surfaces)].flatMap(node => [...node.querySelectorAll(controls)])
      .map(node => ({ node, previous: node.disabled }));
    disabled.forEach(({ node }) => { node.disabled = true; });
    status('Updating ice bag…');
    let attempted = false;
    let saved = false;
    try {
      // Check the live cart, not just the checkbox: another tab may have changed it.
      const cart = await request(`${root}cart.js`);
      const matching = cart.items.filter(item => Number(item.variant_id) === variantId);
      let result = {};
      if (wanted && !matching.length) {
        attempted = true;
        result = await request(`${root}cart/add.js`, {
          items: [{ id: variantId, quantity: 1 }], sections: sectionIds, sections_url: window.location.pathname
        });
      } else if (!wanted && matching.length) {
        attempted = true;
        result = await request(`${root}cart/update.js`, {
          updates: Object.fromEntries(matching.map(item => [item.key, 0])),
          sections: sectionIds, sections_url: window.location.pathname
        });
      }
      saved = true;
      let sections = result.sections || {};
      if (sectionIds.some(id => typeof sections[id] !== 'string')) {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', sectionIds.join(','));
        sections = await request(url.toString());
      }
      if (sectionIds.some(id => typeof sections[id] !== 'string')) throw new Error('Cart display unavailable.');
      document.dispatchEvent(new CustomEvent('tazty:cart-updated', {
        detail: { sections, openDrawer: false, iceBagUpdate: true }
      }));
      status(wanted ? 'Ice bag included in your order.' : 'Ice bag removed from your order.');
      // Section replacement removes the original focused checkbox.
      const nextScope = scope?.id ? document.getElementById(scope.id) : document.querySelector('[data-tazty-cart-page]');
      nextScope?.querySelector('[data-cart-ice-bag-toggle]')?.focus({ preventScroll: true });
    } catch (error) {
      input.checked = wasChecked;
      // Never retry a POST automatically: an interrupted response may still have saved.
      status(saved ? 'Your choice was saved. Please reload the page to see the updated cart.'
        : (error.name === 'TimeoutError' || (attempted && error instanceof TypeError))
          ? 'We could not confirm the update. Please reload the page to check your cart.'
          : error.message, true);
    } finally {
      disabled.forEach(({ node, previous }) => { if (node.isConnected) node.disabled = previous; });
      busy = false;
    }
  }
})();
